import React from "react";
import { collagePages } from "../mock";
import { useSiteData } from "../context/SiteDataContext";
import { getSection, renderMultilineText, sectionStyle } from "../lib/sectionStyles";

const PullQuoteSection = () => {
  const { pullQuotes, siteSections } = useSiteData();
  const section = getSection(siteSections, "home", "home.pull-quotes", {
    eyebrow: "Section 05 - Pull Quotes",
    imageUrl: collagePages.yung,
    imagePosition: "center",
    imageFit: "cover",
    content: { limit: "" },
  });

  if (!section) return null;

  const sortedQuotes = [...pullQuotes].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
  const limit = Number(section.content?.limit);
  const visibleQuotes = Number.isFinite(limit) && limit > 0 ? sortedQuotes.slice(0, limit) : sortedQuotes;

  if (!visibleQuotes.length) return null;

  return (
    <section
      className="relative bg-[var(--red)] text-[var(--pink-soft)] border-y-2 border-[var(--ink)] overflow-hidden"
      style={sectionStyle(section)}
    >
      <div
        className="absolute inset-0 opacity-25 mix-blend-multiply"
        style={{
          backgroundImage: `url(${section.imageUrl || collagePages.yung})`,
          backgroundSize: section.imageFit || "cover",
          backgroundPosition: section.imagePosition || "center",
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 py-24 md:py-32">
        <div className="flex items-center gap-3 mb-8">
          <span className="inline-block w-12 h-px bg-[var(--pink-soft)]" />
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase">
            {section.eyebrow}
          </span>
        </div>

        {visibleQuotes.length === 1 ? (
          <>
            <blockquote className="pull-quote font-editorial italic leading-[0.98] tracking-tight text-[10vw] md:text-[7vw] lg:text-[6vw]">
              {renderMultilineText(visibleQuotes[0].text)}
            </blockquote>
            <p className="mt-10 font-mono text-xs tracking-[0.3em] uppercase">
              - {visibleQuotes[0].attribution}
            </p>
          </>
        ) : (
          <div className="grid md:grid-cols-2 gap-8">
            {visibleQuotes.map((quote, index) => (
              <blockquote
                key={quote.id || `${quote.text}-${index}`}
                className="border-2 border-[var(--pink-soft)]/50 bg-[var(--red-deep)]/30 p-6 md:p-8"
              >
                <p className="font-editorial italic text-4xl md:text-5xl leading-[1.02] tracking-tight">
                  {renderMultilineText(quote.text)}
                </p>
                {quote.attribution ? (
                  <footer className="mt-8 font-mono text-xs tracking-[0.3em] uppercase">
                    - {quote.attribution}
                  </footer>
                ) : null}
                {quote.context ? (
                  <p className="mt-3 text-sm text-[var(--pink-soft)]/80">{quote.context}</p>
                ) : null}
              </blockquote>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PullQuoteSection;
